// extracted by mini-css-extract-plugin
module.exports = {"mapWrapper":"styles_mapWrapper__23GLB","extraPadding":"styles_extraPadding__P2oUv","tightPadding":"styles_tightPadding__2nKju"};